import { styled } from '@mui/material/styles';

export const GoogleAuthContainer = styled('div')({
  display: 'inline-block',
});
